export default "__VITE_ASSET__BLzZvSt4__"